module.exports = __webpack_public_path__ + "img/waist.bf41053d.png";